angular.module('tf.directives')

    .directive('splitResize', ['$rootScope', function($rootScope) {
        return {
            restrict:'A',
            scope:{
                splitResize : '='
            },
            link:function(scope, element, attrs) {

                var storedSize = JSON.parse(localStorage.getItem('split-' + scope.splitResize.selectors[0]));
                var split = Split(scope.splitResize.selectors, {
                    sizes: storedSize || scope.splitResize.initSize || [50, 50],
                    minSize: scope.splitResize.minSize || 10,
                    snapOffset: 5,
                    gutterSize: scope.splitResize.gutterSize || 5,
                    onDragEnd: function () {
                        localStorage.setItem('split-' + scope.splitResize.selectors[0], JSON.stringify(split.getSizes()));
                    },
                    onDrag: function(){
                        $rootScope.$broadcast('reCalcViewDimensions'); // rzSlider re-calc dimensions
                    }
                });

            }
        };
    }]);